/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} State_FinishedInputs */



/**
* | output |
* | --- |
* | "Finished" |
*
* @param {State_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const state_finished = /** @type {((inputs?: State_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<State_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalizado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Terminato")
	return /** @type {LocalizedString} */ ("Finished")
});